import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as http from "./http";

const getApi = () => {
  let hostname = window.location.host;
  var arrValue = hostname.split(".");
  var result = arrValue[0];
  if (result.includes("localhost") === true) {
    result = "http://localhost:8098/";
  } else {
    result = "https://carpadapi.azurewebsites.net/";
  }
 result = "https://carpadapi.azurewebsites.net/";
  
  return result;
};

export const APIUrl = getApi();

 export const showErrorMessage = (message:any) => {
    toast.error(message, {
        position: toast.POSITION.BOTTOM_CENTER,
         theme: "colored" 
    }); 
};
export const showSuccessMessage = (message:any) => {
  toast.success(message, {
      position: toast.POSITION.BOTTOM_CENTER,
       theme: "colored" 
  }); 
};
export const validateEmail = (email:any) => {
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  
export const post = async(resource:any,payload:any,header:any) => { 
  let api = APIUrl + `${resource}`;
  return http.post(api, payload).then((response) => {
    return response;
  });
}
export const get = async(resource:any,header:any) => { 
  let api = APIUrl + `${resource}`;
  return http.get(api).then((response) => {
    return response;
  });
}

export const formatDate = (date:any) => {
  if(date==null)
  {
    return "NA";
  }
  const originalTimestamp = date;
  return new Date(originalTimestamp).toLocaleString('en-US', { timeZone: 'UTC' });
};




